<div class="email-container">

    <form [formGroup]="guestEmailForm" class="email-form">

        <!-- NEW wrapper -->
        <div class="email-header-row">

            <!-- Email + edit -->
            <div class="email-row">

                <label for="newEmail" class="email-label">My Email:</label>

                <!-- Editing mode -->
                <ng-container *ngIf="emailInEditing; else showEmail">

                    <input id="newEmail"
                           type="text"
                           class="form-control email-input"
                           formControlName="emailInput"
                           placeholder="A valid email is required">

                    <button (click)="onSaveEmail(guestEmailForm.get('emailInput')?.value)"
                            class="btn btn-ok email-btn"
                            [disabled]="guestEmailForm.get('emailInput')?.invalid">
                        Ok
                    </button>

                </ng-container>

                <!-- View mode -->
                <ng-template #showEmail>
                    <div class="email-text shrink">
                        {{ emailInHeader() }}
                    </div>

                    <button class="btn btn-ok email-btn edit-inline"
                            (click)="onChangeEmail()">Edit</button>
                </ng-template>

            </div>

            <!-- Menu (now OUTSIDE email-row) -->
            <div *ngIf="!emailInEditing && guestService.guestEmail()"
                 class="menu-container">
                <div class="dropdown" appDropdown>
                    <button class="btn dropdown-toggle menu-btn"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                        <span class="burger-icon"></span>
                    </button>

                    <ul class="dropdown-menu">
                        <li><a routerLink="names" class="dropdown-item">Manage names</a></li>
                        <li><a routerLink="new" class="dropdown-item">Submit a name</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </form>
</div>